
import React from 'react';
import { Link } from 'react-router-dom';
import TourCard from '@/components/TourCard';
import type { FlatTourData } from '@/utils/tourTransformUtils';

interface TourListProps {
  tours: FlatTourData[];
}

const TourList: React.FC<TourListProps> = ({ tours }) => {
  // Transform FlatTourData to Tour format expected by TourCard
  const transformedTours = tours.map(tour => ({
    id: tour.id,
    titleEn: tour.title,
    titleHe: tour.title, // Use the same title for both languages for now
    descriptionEn: tour.description || '',
    descriptionHe: tour.description || '', // Use the same description for both languages for now
    image: tour.cover_image || '/placeholder.svg',
    duration: tour.duration || 0,
    exhibits: tour.exhibits || [],
    exhibitCount: tour.exhibitCount || 0,
    mapType: (tour.mapType as 'indoor' | 'outdoor') || 'indoor',
    mapImage: tour.mapImage || undefined
  }));

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 relative z-10">
      {transformedTours.map(tour => (
        <TourCard key={tour.id} tour={tour} />
      ))}
    </div>
  );
};

export default TourList;
